import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Stack, Typography } from '@emburse/embark-core';
import { useDialog } from '../../components/Dialog';
function useIdentityVerificationModal() {
    const { enqueueDialog } = useDialog();
    const modalProps = {
        title: 'Security Requirement',
        confirmText: 'Continue',
        show: true,
        content: (_jsxs(Stack, { alignItems: "flex-start", spacing: 1, children: [_jsx(Typography, { children: "Viewing banking information requires multi-factor authentication (MFA)" }), _jsx(Typography, { children: "Click \u201CContinue\u201D to enable MFA and authenticate" })] }))
    };
    const enqueueIdentityVerificationModal = (args = {}) => {
        enqueueDialog({
            ...modalProps,
            onConfirm: args.onConfirm,
            onClose: args.onClose
        });
    };
    return { enqueueIdentityVerificationModal };
}
export default useIdentityVerificationModal;
